<div class="layout-wrapper menu-layout-static" [ngClass]="{'layout-menu-static-active': sideBarIsOpened}">
  <app-topbar (toggle)="setSidebarState($event)"></app-topbar>
  <div class="layout-menu-container" [ngClass]="{'layout-menu-container-hidden': !sideBarIsOpened}">
    <p-scrollPanel>
      <div class="menu-scroll-content">
        <app-inline-installation-info class="ng-tns-c1-144 ng-star-inserted"></app-inline-installation-info>
        <app-nav (toggleSidebar)="setSidebarState($event)"></app-nav>
      </div>
    </p-scrollPanel>
  </div>
  <div class="layout-main">
    <div class="layout-mask" (click)="setSidebarState(false)"></div>
    <router-outlet></router-outlet>
  </div>
</div>
